/**
 * @module app.shared
 */

import { IValidator, IValidation, IValidationResult } from 'app/shared/lib/validation/validation-types';

export function applyMaterializeValidationResults(value: any, valueChanged: boolean, validation: IValidation | null, inputElement?: HTMLElement, helperElement?: HTMLElement, label?: string | null) {
    let result: IValidationResult | null = null;
    if(validation) {
        result = validation.validator.validateValue(value, { valueChanged: valueChanged, label: label || undefined })
    }
    if(!validation || !result || !result.enabled) {
        if(inputElement) {
            inputElement.classList.remove('valid');
            inputElement.classList.remove('invalid');
        }
        if(helperElement) {
            helperElement.removeAttribute('data-success');
            helperElement.removeAttribute('data-error');
        }
    }
    else if(result.valid) {
        if(inputElement) {
            inputElement.classList.add('valid');
            inputElement.classList.remove('invalid');
        }
        if(helperElement) {
            helperElement.setAttribute('data-success', result.message);
            helperElement.removeAttribute('data-error');
        }
    }
    else {
        if(inputElement) {
            inputElement.classList.add('invalid');
            inputElement.classList.remove('valid');
        }
        if(helperElement) {
            helperElement.removeAttribute('data-success');
            helperElement.setAttribute('data-error', result.message);
        }
    }
}

export function validatePostalCode(postalCode: string): boolean {
    // Copilot Start
    // Accept:
    //  - 5 digit: 12345
    //  - 9 digit: 123456789
    //  - 5 digit + dash + 4 digit: 12345-6789
    return /^(?:\d{5}(?:-\d{4})?|\d{9})$/.test(postalCode);
    // Copilot End
}

export function validatePhoneNumber(phoneNumber: string): boolean {
    // Only allow 10 digits as this is what the API supports presently
    // The country code +1 is added by the API
    return /^\(?\d{3}?\)?[-.\s]?\d{3}[-.\s]?\d{4}[-.\s]?$/.test(phoneNumber);
}

export function validateEmail(email: string): boolean {
    return /^\s*\S+@\S+\.\S+\s*$/.test(email);
}

export function validateWebsiteUrl(websiteUrl: string): boolean {
    // Character lengths limited to match backend column limits // nvarchar (1000)
    return /(^http(s)?):\/\/[(www\.)?a-zA-Z0-9@:%._\+~#=]{1,980}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/.test(websiteUrl);
}

export function validateSSN(ssn: string): boolean {
    // Only allow 9 digits with optional dash format
    return /^((\d{3}-\d{2}-\d{4})|\d{9})$/.test(ssn);
}
